import React from "react";
import Barcode from 'react-barcode';
import ProductLong_776 from "components/Labels/ProductLong_776";
import ProductLong_2291 from "components/Labels/ProductLong_2291";
import ProductLong_2940 from "components/Labels/ProductLong_2940";
import ProductLong_3186 from "components/Labels/ProductLong_3186";
import APPCONFIG from "constants/Config";

/**
 * @param {Products_Object} product
 * @param visible
 */
export default ({product, visible = false, acquisition = null}) => {
	let maxCharacters = 12;
	let minCharacters = 5;

	let cutBarCodeText = (text)=> {
		return text.substr(0, maxCharacters);
	};
	let cutBarCodeTextExtra = (text)=> {
		return ' ' + text.substr(maxCharacters);
	};
	let getBarCodeWidth = (text) => {
		let smallest = 1.6;
		let largest = 2.5;
		let range = largest - smallest;
		let charRange = maxCharacters - minCharacters;
		let widthSegmentPerCharacter = range / charRange;
		let charsOverMin = text.length - minCharacters;
		let additionalSize = widthSegmentPerCharacter * charsOverMin;
		let newSize = largest - additionalSize;
		return Math.min(Math.max(newSize, smallest), largest);
	};

	let value = product.id ? product.id : ('P-'+parseInt(product.binary_id.trim())+'-'+product.pkey);

	return (
		<div className="ProductLong" style={{
			textAlign: "center",
			width: '285px',
			height: '382px',

			...visible ? {
				border: '1px solid black',
				borderRadius: '10px',
				display: 'inline-block'
			} : {
				pageBreakBefore: 'always',

				marginLeft: "1px",
			}
		}}>
			<div style={{borderBottom: '2px solid black', padding: '60px 0 10px 0'}}>
				<img
					src={APPCONFIG.settings.apiURL() + '/images/labels/logo_3186.png'}
					style={{display: 'block', width: '210px', margin: '0 auto'}}
					alt={'Girard Auction & Land Brokers, Inc.'}
				/>
			</div>
			<div className="serialNumber" style={{fontSize: '20px'}}>
				{product.serial_number}
			</div>
			<div className="notes" style={{padding: "10px 0 5px 0", marginBottom: '20px', fontSize: "16px", borderBottom: '2px solid black'}}>
				<div style={{marginBottom: '8px'}}>
					{product.importer && `${product.importer} / `}
					{!product.manufacturer_other && product.manufacturers ? product.manufacturers.name : product.manufacturer_other}
				</div>

				<div style={{marginBottom: '8px'}}>{product.model}</div>

				<div style={{marginBottom: '8px'}}>{!product.caliber_other && product.calibers ? product.calibers.name : product.caliber_other}</div>

				{product.tag_note && <div style={{marginBottom: '8px'}}>{product.tag_note}</div>}
				
				{acquisition && <div style={{marginBottom: '8px'}}>{acquisition}</div>}
			</div>

			<div className="pageBreak"/>
		</div>
	);
};
